import Vue from "vue";
import Vuex from "vuex";
import { auth, dbFB, storage, functions } from "../components/firebase.js";

Vue.use(Vuex);

import propietarios from "./modules/propietarios";
import adminRegisterUsers from "./modules/admin-register-users";
import adminForms from "./modules/admin-forms-users";

export const store = new Vuex.Store({
  state: {
    debug: false,
    debugUsers: false,
    lintersDbAct: [],
    user: null,
    users: null,
    usersPreReg: null,
    usuario: null,
    level: 0,
    expedientes: null,
    estadisticasExpedientes: null,
    expedientesStatus: null,
    catastro: null,
    estadisticasCatastro: null,
    catastroUsers: null,
    municipios: null,
    provincias: null,
    comunidades: null,
    alertaCatastro: null,
    configApp: null,
    newUserRegisterId: null,
    respuestaSistema: null,
    respuestaSistemaUsers: null,
    eventosUser: null,
    eventosGlobal: null,
    feedBack: null,
    provinciaMunicipiosCargados: null,
    navegationControl: {
      expedientesList: {
        pagination: false,
        filtros: {
          provincia: [],
          gestor: [],
          admon: [],
          status: []
        }
      },
      expedienteEdit: {},
      inmueblesList: {
        pagination: false,
        filtros: {
          uso: [],
          volante: [],
          anexo3: [],
          anexo4: []
        }
      },
      inmuebleEdit: {},
      usuariosList: {
        pagination: false,
        filtros: {
          rol: []
        }
      },
      usuarioEdit: {}
    }
  },
  modules: {
    propietarios,
    adminRegisterUsers,
    adminForms
  },
  getters: {
    smsConfig: state => {
      return state.configApp.functions.sms
    },
    navegationControl: state => {
      return state.navegationControl;
    },
    debug: state => {
      return state.debug;
    },
    getUser: state => {
      return state.user;
    },
    getUserUid: state => {
      return state.user ? state.user.uid : false;
    },
    getUsers: state => {
      return state.users;
    },
    getUsersPreReg: state => {
      return state.usersPreReg;
    },
    getUserPreRegisterData: state => token => {
      let result = {
        email: false,
        tlf: false,
        tlfVerified: false,
        sinEmail: false,
        password: false,
        displayName: false,
        verificarEmail: true
      };
      if (state.usersPreReg) {
        const usr = state.usersPreReg[token.preUserTlf];
        if (usr) {
          result.tlf = usr.preUserTlf;
          result.tlfVerified = true;
          result.expediente = usr.expediente;
          result.refCatastro = usr.ref;
          result.refInmueble = usr.inmueble;
          result.name = usr.preUserName;
        }
      }
      return result;
    },
    getLevel: state => {
      return state.level;
    },
    level: state => {
      return state.level;
    },
    getRoles: state => {
      let result = [];
      if (state.configApp && state.configApp.roles) {
        result = state.configApp.roles.filter(
          item => item.level <= state.level
        );
      }
      // return state.configApp ? state.configApp.roles : []
      return result;
    },
    getUsuario: state => {
      return state.usuario;
    },
    getUsuarioId: state => idx => {
      return state.users ? state.users[idx] : null;
    },
    getUsuarioAdmin: state => {
      return state.users ? state.users[state.user.uid] : null;
    },
    getUsuarioAdd: state => {
      return state.usuario || "sin datos";
    },
    getUserSelected: state => (idx = null) => {
      // let result = JSON.parse(JSON.stringify(state.usuarioBase));
      let result = state.configApp
        ? JSON.parse(JSON.stringify(state.configApp.userModel.private))
        : false;
      if (result) {
        const userSel = idx && state.users ? state.users[idx] : state.usuario;
        if (userSel.private) {
          Object.assign(result, userSel.private);
        }
        if (state.level > 6) {
          result.admin = userSel.admin;
        }
      }
      return result;
      // return idx ? state.users[idx] : state.usuario;
    },
    getUsuarioSeleccionado: state => (idx = null) => {
      let result = state.configApp
        ? JSON.parse(JSON.stringify(state.configApp.userModel))
        : false;
      if (result) {
        const userSel = idx && state.users ? state.users[idx] : false;
        if (userSel) {
          Object.assign(result, userSel);
        }
      }
      return result;
    },
    getExpedienteModelo: state => {
      return state.configApp ? state.configApp.modelos.expediente : null;
    },
    getExpedientesActivos: state => {
      return state.expedientes
        ? Object.keys(state.expedientes)
            .map(i => {
              return { detalle: state.expedientes[i], idx: i };
            })
            .filter(item => item.detalle.status !== "Desactivado")
        : [];
      // return state.expedientes;
    },
    getExpedienteSelected: (state, getters) => idx => {
      return getters.getExpedientesActivos.filter(item => item.idx === idx)[0];
    },
    getExpedientesStatus: state => {
      return state.expedientesStatus;
    },
    getCatastro: state => {
      return state.catastro;
    },
    getCatastroId: state => idx => {
      return state.catastro[idx] || false;
    },
    getCatastroIdInmuebles: state => idx => {
      return state.catastro[idx] ? state.catastro[idx].inmuebles : null;
    },
    getInmuebleId: state => payload => {
      const idx = payload.refCatastral;
      const id = payload.id;
      const result = {
        inmueble: state.catastro[idx]
          ? state.catastro[idx].inmuebles[id]
          : null,
        catastroUsers: state.catastro[idx]
          ? state.catastro[idx].catastroUsers
            ? state.catastro[idx].catastroUsers[id]
            : []
          : null
      };
      return result;
    },
    getMunicipiosSelect: state => {
      // return state.municipios;
      const objeto = state.municipios;
      let array = [];
      if (objeto) {
        array = objeto.map((item, key) => {
          return {
            text: item,
            value: key
          };
        });
      }
      array.unshift({
        text: "Seleccionar",
        value: null
      });
      return array;
    },
    getProvinciasSelect: state => {
      // return state.provincias;
      const objeto = state.provincias;
      let array = [];
      if (objeto) {
        array = objeto.map(item => {
          return {
            text: item.provinciaName,
            value: item.provinciaId
          };
        });
      }
      array.unshift({
        text: "Seleccionar",
        value: null
      });
      return array;
    },
    getItemsMenu: state => {
      return state.configApp
        ? state.configApp.UI.itemsMenu.filter(
            item => item.minLevel <= state.level
          )
        : [];
    },
    getItemsMenuAdmin: state => {
      return state.configApp
        ? state.configApp.UI.itemsMenuAdmin.filter(
            item => item.minLevel <= state.level
          )
        : [];
    },
    getItemsGestionMenu: state => {
      return state.configApp
        ? state.configApp.UI.itemsGestionMenu.filter(
            item => item.minLevel <= state.level
          )
        : [];
    },
    getUsersArray: state => {
      return state.users
        ? Object.keys(state.users).map(i => {
            return { data: state.users[i], idx: i };
          })
        : [];
    },
    getUsersInmuebles: (state, getters) => {
      return getters.getUsersArray
        .map(item => {
          return {
            idx: item.idx,
            inmuebles: item.data.private.inmuebles
              ? Object.keys(item.data.private.inmuebles)
              : false
          };
        })
        .filter(item => item.inmuebles);
    },
    getUsersList: (state, getters) => {
      const objeto = getters.getUsersArray;
      let array = [];
      if (objeto.length > 0) {
        array = objeto.map(item => {
          const tlf = item.data.private ? item.data.private.tlf1 : "";
          /* let rol = 'Usuario'
                    if (item.data.admin.isAdmin) {
                        rol = 'Administrador'
                    }
                    if (item.data.admin.level > 4) {
                        rol = 'Gestor'
                    }
                    if (item.data.admin.level > 9) {
                        rol = 'Supervisor'
                    } */
          return {
            idx: item.idx,
            nombre: item.data.private ? item.data.private.nombre || "" : "",
            apellidos: item.data.private
              ? `${item.data.private.apellido1 || ""} ${item.data.private
                  .apellido2 || ""}`
              : "",
            email: item.data.admin.email,
            tlf: tlf,
            rol: item.data.admin.rol
          };
        });
      }
      return array;
    },
    getAdminFincas: (state, getters) => {
      const objeto = getters.getUsersArray;
      let array = [];
      if (objeto.length > 0) {
        array = objeto
          .filter(item => item.data.admin.isAdminFicas)
          .map(item => {
            return {
              idx: item.idx,
              name: item.data.private
                ? `${item.data.private.nombre || item.idx} ${item.data.private
                    .apellidos || ""}`
                : item.data.admin.email
            };
          });
      }
      array.unshift({
        idx: false,
        name: "Ninguno Seleccionado"
      });
      return array;
    },
    getAdminFincasObject: (state, getters) => {
      const array = getters.getAdminFincas
        ? getters.getAdminFincas.filter(item => item.idx)
        : [];
      let objeto = {};
      if (array.length > 1) {
        objeto = array.reduce((obj, item) => {
          obj[item["idx"]] = item.name;
          return obj;
        }, {});
      }
      return objeto;
    },
    getGestores: (state, getters) => {
      const objeto = getters.getUsersArray;
      let array = [];
      if (objeto.length > 0) {
        array = objeto
          .filter(item => item.data.admin.level > 4)
          .map(item => {
            return {
              idx: item.idx,
              name: item.data.private
                ? `${item.data.private.nombre || item.idx} ${item.data.private
                    .apellidos || ""}`
                : item.data.admin.email
            };
          });
      }
      array.unshift({
        idx: false,
        name: "Ninguno Seleccionado"
      });
      return array;
    },
    getGestoresObject: (state, getters) => {
      const array = getters.getGestores
        ? getters.getGestores.filter(item => item.idx)
        : [];
      let objeto = {};
      if (array.length > 1) {
        objeto = array.reduce((obj, item) => {
          obj[item["idx"]] = item.name;
          return obj;
        }, {});
      }
      return objeto;
    },
    getComunidades: state => {
      return state.comunidades;
    },
    getComunidadId: state => id => {
      return state.comunidades[id] || null;
    },
    getAlertaCatastro: state => {
      return state.alertaCatastro;
    },
    getConfigApp: state => {
      return state.configApp;
    },
    getIsConfigApp: state => {
      return state.configApp !== null;
    },
    getNewUserRegisterId: state => {
      return state.newUserRegisterId;
    },
    getRespuestaSistema: state => {
      return state.newUserRegisterId
        ? state.respuestaSistema[state.newUserRegisterId]
        : false;
    },
    getEventosUser: state => {
      return state.eventosUser ? state.eventosUser : false;
    },
    getEventosGlobal: state => {
      return state.eventosGlobal ? state.eventosGlobal : false;
    },
    getTemaColorAdminUI: state => {
      return state.configApp ? state.configApp.UI.temaColor.admin : "red";
    },
    getCatastroUsers: state => idx => {
      return state.catastroUsers[idx] ? state.catastroUsers[idx].inmuebles : [];
    },
    getPropietariosCatastro: state => idx => {
      const cat = state.catastro[idx];
      const users = cat.catastroUsers ? cat.catastroUsers : false;
      let list = [];
      if (users && users.length > 0) {
        const keys = Object.keys(users);
        for (const key of keys) {
          list.push(users[key]);
        }
      }
      return users;
    },
    isMayor65OrDiscapacidad: state => idx => {
      let result = {
        mayor65: false,
        discapacidad: false
      };
      const user = state.users[idx].private;
      if (user) {
        const discapacidad = user.discapacidad || false;
        if (discapacidad && discapacidad.isDiscapacidad) {
          result.discapacidad = discapacidad;
        }
        if (
          user.fechaNacimientoYear &&
          user.fechaNacimientoMes &&
          user.fechaNacimientoDia
        ) {
          const fechaHoy = new Date();
          const fNacimiento = new Date(
            `${user.fechaNacimientoYear}-${user.fechaNacimientoMes}-${
              user.fechaNacimientoDia
            }`
          );
          const difYear = fechaHoy.getFullYear() - fNacimiento.getFullYear();
          if (difYear > 65) {
            result.mayor65 = difYear;
          }
          // Afinar en el mes y día
          if (difYear === 65) {
            const difMes = fechaHoy.getMonth() - fNacimiento.getMonth();
            // Mes
            if (difMes > 0) {
              result.mayor65 = difYear;
            }
            // Día
            if (difMes === 0) {
              const difDia = fechaHoy.getDate() - fNacimiento.getDate();
              if (difDia > -1) {
                result.mayor65 = difYear;
              }
            }
          }
        }
      }
      return result;
    }
    /* ,
        getDireccionCatastral: (payload) => {
            if (payload && payload.refCatastral && payload.idInmueble) {
                dbFB.ref('newCatastro').child(payload.refCatastral).child(payload.idInmueble).once('value')
                    .then(snapshot => {
                        // eslint-disable-next-line
                        // console.log(`${snapshot.val()}`)
                        return snapshot.val();
                    });
            } else {
                return null;
            }
        } */
  },
  mutations: {
    setUser: state => {
      state.user = auth.currentUser;
    },
    setUsers: (state, payload) => {
      state.users = payload;
    },
    setUserUid: (state, payload) => {
      // state.users[payload.uid].private = payload.data
      dbFB
        .ref("users")
        .child(payload.uid)
        .child("private")
        .update(payload.data);
    },
    updateUser: (state, payload) => {
      let data = state.users[payload.uid];
      if (!data) {
        return;
      }
      Object.assign(data, payload.data);
      dbFB
        .ref("users")
        .child(payload.uid)
        .set(data); // .update(payload.data);
    },
    setUsersPreReg: (state, payload) => {
      state.usersPreReg = payload;
    },
    setLevel: (state, payload) => {
      state.level = payload;
    },
    setUsuario: (state, payload) => {
      state.usuario = payload;
    },
    setExpedientes: (state, payload) => {
      state.expedientes = payload;
    },
    setExpedientesStatus: (state, payload) => {
      state.expedientesStatus = payload;
    },
    setCatastroMutation: (state, payload) => {
      state.catastro = payload;
    },
    setMunicipios: (state, payload) => {
      state.municipios = payload;
    },
    setProvincias: (state, payload) => {
      state.provincias = payload;
    },
    setComunidades: (state, payload) => {
      state.comunidades = payload;
    },
    setAlertaCatastro: (state, payload) => {
      state.alertaCatastro = payload;
    },
    updateExpedientes: (state, payload) => {
      const idx = payload.idx;
      const data = payload.data;
      dbFB
        .ref("expedientes")
        .child(idx)
        .update(data);
    },
    newExpediente: (state, payload) => {
      let nuevoExpediente = payload; //JSON.parse(JSON.stringify(payload));
      const idx = payload.expediente;
      // delete nuevoExpediente.expediente;
      nuevoExpediente.creadoPor = state.user.uid;
      // nuevoExpediente.gestor = state.user.uid
      dbFB
        .ref("expedientes")
        .child(idx)
        .set(nuevoExpediente);
      // dbFB.ref('crearNuevoExpediente').push(nuevoExpediente);
    },
    newExpediente_old: (state, payload) => {
      const idx = payload.expediente;
      const catastro = payload.catastro;
      const objCatastro = {
        datos: payload.datos,
        inmuebles: payload.inmuebles,
        expediente: idx,
        ca: payload.ca
      };
      const objExpediente = {
        admon: false,
        creadoPor: state.user.uid,
        fecha: payload.fecha,
        gestor: payload.gestor || state.user.uid,
        status: "Iniciado",
        timeStamp: payload.timeStamp,
        refCatastro: catastro,
        provincia: payload.datos.dir_provinciaName,
        ca: payload.ca
      };
      dbFB
        .ref("expedientes")
        .child(idx)
        .update(objExpediente);
      dbFB
        .ref("catastro")
        .child(catastro)
        .update(objCatastro);
    },
    nuevaAlertaCatastro: (state, payload) => {
      // Sólo permite realizar una búqueda a la vez para evitar colisiones
      if (!state.alertaCatastro.nuevaBuequeda) {
        dbFB
          .ref("alertaCatastro")
          .child("encontrado")
          .set(false);
        dbFB
          .ref("alertaCatastro")
          .child("nuevaBusqueda")
          .set(payload);
      }
    },
    alertaCatastroResultReset: state => {
      if (state.alertaCatastro.result) {
        dbFB
          .ref("expedientes")
          .child("result")
          .set(false);
      }
    },
    setConfigApp: (state, payload) => {
      state.configApp = payload;
    },
    newRegisterUser: (state, payload) => {
      const tabla = state.configApp
        ? state.configApp.tablas.usuariosTriget.prod
        : false;
      if (tabla) {
        let registro = dbFB.ref(tabla).push();
        state.newUserRegisterId = registro.key;
        /* let data = payload
                data.responder = {
                    talbla: state.configApp.tablas.respuestasSistema.noAuth,
                    id: state.newUserRegisterId
                } */
        registro.set(payload);
        // dbFB.ref(tabla).child(registro).set(data)
      }
    },
    setRespuestaSistema: (state, payload) => {
      state.respuestaSistema = payload;
    },
    setRespuestaSistemaUser: (state, payload) => {
      state.respuestaSistemaUsers = payload;
    },
    setEventosUser: (state, payload) => {
      state.eventosUser = payload;
    },
    setEventosGlobal: (state, payload) => {
      state.eventosGlobal = payload;
    },
    setEventoLeido: (state, payload) => {
      dbFB
        .ref("systemEvents")
        .child("users")
        .child(state.user.uid)
        .child(payload)
        .set(null);
    },
    subirFileCatastro: payload => {
      storage.ref().put(payload);
    },
    updateCatastroExpediente: (state, payload) => {
      const expediente = payload.expediente;
      const refCatastro = payload.refCatastro;
      if (expediente && refCatastro) {
        dbFB
          .ref("catastro")
          .child(refCatastro)
          .child("expediente")
          .set(expediente);
      }
    },
    updateCatastroInmuebles: (state, payload) => {
      const inmuebles = payload.inmuebles;
      const refCatastro = payload.idx;
      if (inmuebles && refCatastro) {
        dbFB
          .ref("catastro")
          .child(refCatastro)
          .child("inmuebles")
          .set(inmuebles);
      }
    },
    updateNewCatastroInmuebles: (state, payload) => {
      const inmuebles = payload.inmuebles;
      const refCatastro = payload.idx;
      if (inmuebles && refCatastro) {
        dbFB
          .ref("newCatastro")
          .child(refCatastro)
          .child("inmuebles")
          .set(inmuebles);
      }
    },
    nuevoUsuarioMutation: (state, payload) => {
      const modeloUsuario = state.configApp ? state.configApp.userModel : false;
      const userUid = payload;
      if (modeloUsuario) {
        dbFB
          .ref("users")
          .child(userUid)
          .set(modeloUsuario);
      }
    },
    deleteUsuario: (state, payload) => {
      if (state.level > 10 && payload && state.users[payload]) {
        dbFB
          .ref("usersDeleted")
          .child(payload)
          .set(state.users[payload]);
        dbFB
          .ref("users")
          .child(payload)
          .set(null);
      }
    },
    addUserInmueble: (state, payload) => {
      if (state.level > 5 && payload) {
        const cat = state.catastro[payload.refCatastral];
        if (cat) {
          const catastroUsers = cat.catastroUsers;
          let usuarios = [];
          const nuevoUsuario = {
            id: payload.idUser,
            tipo: false,
            cuota: 0,
            empadronado: false
          };
          const huellaUser = {
            refCatastral: payload.refCatastral,
            idInmueble: payload.idInmueble
          };
          if (catastroUsers && catastroUsers[payload.idInmueble]) {
            usuarios = catastroUsers[payload.idInmueble];
            if (usuarios.includes(payload.idUser)) {
              state.feedBack = {
                error: true,
                message: `El usuario ${
                  payload.idUser
                } ya existe en el inmuble ${
                  payload.idInmueble
                } de la ref. catastral ${payload.refCatastral}`
              };
              return;
            }
          }
          usuarios.push(nuevoUsuario);
          dbFB
            .ref("catastro")
            .child(payload.refCatastral)
            .child("catastroUsers")
            .child(payload.idInmueble)
            .set(usuarios);
          if (!payload.omiteHuellaUser) {
            dbFB
              .ref("users")
              .child(payload.idUser)
              .child("private")
              .child("inmuebles")
              .child(payload.inmuebleUser)
              .set(huellaUser);
          }
          state.feedBack = {
            error: false,
            message: `El usuario ${
              payload.idUser
            } ha sido agregado al inmuble ${
              payload.idInmueble
            } de la ref. catastral ${payload.refCatastral}`
          };
          return;
        }
      }
    },
    inmuebleUserUpdate: (state, payload) => {
      dbFB
        .ref("catastro")
        .child(payload.refCatastral)
        .child("catastroUsers")
        .child(payload.idInmueble)
        .set(payload.inmuebleUsers);
    },
    inmuebleDatosUpdate: (state, payload) => {
      dbFB
        .ref("catastro")
        .child(payload.refCatastral)
        .child("inmuebles")
        .child(payload.idInmueble)
        .set(payload.inmuebleDatos);
    },
    deleteUserInmueble: (state, payload) => {
      const array = state.catastro[payload.refCatastral].catastroUsers[
        payload.idInmueble
      ].map(item => item.id);
      const indice = array.indexOf(payload.idUser);

      dbFB
        .ref("catastro")
        .child(payload.refCatastral)
        .child("catastroUsers")
        .child(payload.idInmueble)
        .child(indice)
        .set(null);

      dbFB
        .ref("users")
        .child(payload.idUser)
        .child("private")
        .child("inmuebles")
        .child(payload.inmuebleUser)
        .set(null);
    },
    setEnviaLinkRegistroUserMuta: (state, payload) => {
      // Date.now()
      const email = state.users[payload].admin.email;
      dbFB
        .ref("users")
        .child(payload)
        .child("admin")
        .child("linkRegisterIn")
        .set(email);
    },
    setEstadisticasExpedientesMutation: (state, payload) => {
      state.estadisticasExpedientes = payload;
    },
    setEstadisticasCatastroMutation: (state, payload) => {
      state.estadisticasCatastro = payload;
    }
  },
  actions: {
    setLocalesPartcipan: (state, payload) => {
      // eslint-disable-next-line
      // console.log(payload);
      dbFB
        .ref("expedientes")
        .child(`${payload.id}`)
        .child("localesParticipan")
        .set(payload.valor);
        // .update({localesParticipan: payload.valor});
    },
    setUser: context => {
      context.commit("setUser");
    },
    setUsers: context => {
      if (context.state.debugUsers) {
        return;
      }
      // Hay que limitar esto
      if (context.state.lintersDbAct.includes("users")) {
        return;
      }
      context.state.lintersDbAct.push("users");
      dbFB.ref(`users`).on("value", snapshot => {
        if (snapshot.val() !== null) {
          context.commit("setUsers", snapshot.val());
        }
      });
    },
    setUserUid: (context, payload) => {
      if (payload.uid && payload.data) {
        context.commit("setUserUid", payload);
      }
    },
    updateUser: (context, payload) => {
      if (payload.uid && payload.data) {
        context.commit("updateUser", payload);
      }
    },
    updateUsuario: (context, payload) => {
      const data = {
        uid: context.state.user.uid,
        data: payload
      };
      context.commit("setUserUid", data);
    },
    setUsersPreReg: context => {
      if (context.state.lintersDbAct.includes("usersPrereg")) {
        return;
      }
      context.state.lintersDbAct.push("usersPrereg");
      dbFB.ref(`usersPrereg`).on("value", snapshot => {
        context.commit("setUsersPreReg", snapshot.val());
      });
    },
    setLevel: context => {
      /* if (context.state.lintersDbAct.includes('level')) {
                return
            } */
      if (context.state.user) {
        // eslint-disable-next-line
                // console.log(`SetLevel: Paso 1, uid = ${context.state.user.uid}`)
        dbFB
          .ref("users")
          .child(context.state.user.uid)
          .child("admin")
          .child("level")
          .once("value")
          .then(snapshot => {
            // eslint-disable-next-line
                    // console.log(`${snapshot.val()}`)
            context.commit("setLevel", snapshot.val());
          });
      }
    },
    setUsuario: context => {
      if (context.state.lintersDbAct.includes("setUsuario")) {
        return;
      }
      context.state.lintersDbAct.push("setUsuario");
      let child =
        context.state.level > 6
          ? context.state.user.uid
          : `${context.state.user.uid}/private`;
      dbFB
        .ref("users")
        .child(child)
        .on("value", snapshot => {
          if (snapshot.val() !== null) {
            context.commit("setUsuario", snapshot.val());
          }
        });
    },
    setLevel_old: context => {
      // eslint-disable-next-line
            console.log('SetLevel')
      if (context.state.user) {
        // eslint-disable-next-line
                // console.log(`SetLevel: Paso 1, uid = ${context.state.user.uid}`)
        dbFB.ref(`users/${context.state.user.uid}`).on("value", snapshot => {
          // eslint-disable-next-line
                    console.log(`${snapshot.val()}`)
          if (snapshot.val() !== null) {
            // eslint-disable-next-line
                        console.log('SetLevel: Paso 2')
            context.commit("setUsuario", snapshot.val());
            let level = snapshot.val().admin.level;
            if (level) {
              // eslint-disable-next-line
                            console.log('SetLevel: Paso 3')
              context.commit("setLevel", level);
            }
          }
        });
      }
    },
    setExpedientes: context => {
      if (context.state.lintersDbAct.includes("setExpedientes")) {
        return;
      }
      context.state.lintersDbAct.push("setExpedientes");
      dbFB.ref(`expedientes`).on("value", snapshot => {
        if (snapshot.val() !== null) {
          context.commit("setExpedientes", snapshot.val());
        }
      });
    },
    setExpedientesStatus: context => {
      if (context.state.lintersDbAct.includes("setExpedientesStatus")) {
        return;
      }
      context.state.lintersDbAct.push("setExpedientesStatus");
      dbFB.ref(`statusexptes`).once("value", snapshot => {
        if (snapshot.val() !== null) {
          context.commit("setExpedientesStatus", snapshot.val());
        }
      });
    },
    setCatastro: context => {
      if (context.state.lintersDbAct.includes("setCatastro")) {
        return;
      }
      context.state.lintersDbAct.push("setCatastro");
      // eslint-disable-next-line
            // console.log(`En setCatastro ${context.state.lintersDbAct.includes('setCatastro')}`)

      dbFB.ref(`catastro`).on("value", snapshot => {
        if (snapshot.val() !== null) {
          context.commit("setCatastroMutation", snapshot.val());
        }
      });
    },
    setMunicipios: (context, payload) => {
      // eslint-disable-next-line
            console.log(`setMunicipios: payload = ${payload}`);
      if (payload) {
        if (context.state.provinciaMunicipiosCargados === payload) {
          return;
        }
        context.state.provinciaMunicipiosCargados = payload;
        // let result = [];
        dbFB
          .ref(`municipios`)
          .child(payload)
          .once("value")
          .then(snapshot => {
            if (snapshot.val() !== null) {
              // result = snapshot.val();
              context.commit("setMunicipios", snapshot.val());
            }
          })
          .catch(err => {
            // eslint-disable-next-line
                    console.log(`setMunicipios: error: ${err.message}`);
          });
      }
    },
    setProvincias: context => {
      dbFB.ref(`provincias`).once("value", snapshot => {
        context.commit("setProvincias", snapshot.val());
        /* if (snapshot.val() !== null) {
                    context.commit('setProvincias', snapshot.val());
                } */
      });
    },
    setComunidades: context => {
      dbFB.ref(`ca`).once("value", snapshot => {
        context.commit("setComunidades", snapshot.val());
        /* if (snapshot.val() !== null) {
                    context.commit('setComunidades', snapshot.val());
                } */
      });
    },
    setAlertaCatastro: context => {
      dbFB.ref(`alertaCatastro`).on("value", snapshot => {
        context.commit("setAlertaCatastro", snapshot.val());
        /* if (snapshot.val() !== null) {
                    context.commit('setAlertaCatastro', snapshot.val());
                } */
      });
    },
    updateExpedientes: (context, payload) => {
      context.commit("updateExpedientes", payload);
    },
    newExpediente: (context, payload) => {
      context.commit("newExpediente", payload);
    },
    nuevaAlertaCatastro: (context, payload) => {
      context.commit("nuevaAlertaCatastro", payload);
    },
    alertaCatastroResultReset: context => {
      context.commit("alertaCatastroResultReset");
    },
    setConfigSms: (context, payload) => {
      if (!payload) {
        console.error('Faltan los datos para SMS config')
        return
      }
      dbFB
        .ref("configApp")
        .child("functions")
        .child("sms")
        .set(payload);
    },
    setConfigApp: context => {
      if (context.state.lintersDbAct.includes("setConfigApp")) {
        return;
      }
      context.state.lintersDbAct.push("setConfigApp");
      dbFB.ref(`configApp`).on("value", snapshot => {
        if (snapshot.val() !== null) {
          console.log(snapshot.val())
          context.commit("setConfigApp", snapshot.val());
        }
      });
    },
    newRegisterUser: (context, payload) => {
      // 1 - Comprobar que no exista ya el correo en la base de datos
      context.commit("newRegisterUser", payload);
    },
    setRespuestaSistema: (context, tabla) => {
      // const tabla = state.configApp ? state.configApp.tablas.respuestasSistema.noAuth : false
      // eslint-disable-next-line
            console.log(`Tabla: ${tabla}`)
      if (tabla) {
        // dbFB.ref(tabla).child(payload).on('value', snapshot => {
        dbFB.ref(tabla).on("value", snapshot => {
          // eslint-disable-next-line
                    console.log(snapshot)
          if (snapshot.val() !== null) {
            context.commit("setRespuestaSistema", snapshot.val());
          }
        });
      }
    },
    setEventosUser: context => {
      dbFB
        .ref(`systemEvents`)
        .child("users")
        .child(context.state.user.uid)
        .on("value", snapshot => {
          context.commit("setEventosUser", snapshot.val());
        });
    },
    setEventosGlobal: context => {
      if (context.state.lintersDbAct.includes("setEventosGlobal")) {
        return;
      }
      context.state.lintersDbAct.push("setEventosGlobal");
      dbFB
        .ref(`systemEvents`)
        .child("global")
        .on("value", snapshot => {
          context.commit("setEventosGlobal", snapshot.val());
        });
    },
    setEventoLeido: (context, payload) => {
      context.commit("setEventoLeido", payload);
    },
    subirFileCatastro: (context, payload) => {
      context.commit("subirFileCatastro", payload);
    },
    updateCatastroExpediente: (context, payload) => {
      context.commit("updateCatastroExpediente", payload);
    },
    updateCatastroInmuebles: (context, payload) => {
      context.commit("updateCatastroInmuebles", payload);
    },
    updateNewCatastroInmuebles: (context, payload) => {
      context.commit("updateNewCatastroInmuebles", payload);
    },
    nuevoUsuario: (context, payload) => {
      context.commit("nuevoUsuarioMutation", payload);
    },
    deleteUsuario: (context, payload) => {
      context.commit("deleteUsuario", payload);
    },
    addUserInmueble: (context, payload) => {
      context.commit("addUserInmueble", payload);
    },
    inmuebleUserUpdate: (context, payload) => {
      context.commit("inmuebleUserUpdate", payload);
    },
    inmuebleDatosUpdate: (context, payload) => {
      context.commit("inmuebleDatosUpdate", payload);
    },
    deleteUserInmueble: (context, payload) => {
      context.commit("deleteUserInmueble", payload);
    },
    setEnviaLinkRegistroUser: (context, payload) => {
      context.commit("setEnviaLinkRegistroUserMuta", payload);
    },
    setEstadisticasExpedientes: context => {
      dbFB.ref(`estadisticasExpedientes`).on("value", snapshot => {
        context.commit("setEstadisticasExpedientesMutation", snapshot.val());
      });
    },
    setEstadisticasCatastro: context => {
      dbFB.ref(`estadisticasCatastro`).on("value", snapshot => {
        context.commit("setEstadisticasCatastroMutation", snapshot.val());
      });
    }
  }
});
